import { SearchOnMap } from '@/components/SearchOnMap'
import { InspectPinMode, Map as MainMap, MapLayer } from '@/map'

interface Props {
  bottomContentPadding?: number
}

export function Map(props: Props) {
  return (
    <MainMap
      selectionContext="main"
      mapId="ww-map"
      bottomContentPadding={props.bottomContentPadding}
    >
      <InspectPinMode mode="normal" />

      <MapLayer uid="order" interactive />
      <MapLayer uid="place" interactive />
      <MapLayer uid="depot" interactive />
      <MapLayer uid="vehicle" interactive />
      <MapLayer uid="region" />
      <MapLayer uid="roadSegment" />
      <MapLayer uid="geofence" visible={false} />
      <MapLayer uid="routePolyline" />

      <MapLayer uid="breadcrumbPath" />
      <MapLayer uid="breadcrumbPoints" visible interactive />

      <SearchOnMap />
      {/* TODO: Add remaining layers once they are implemented */}
    </MainMap>
  )
}
